import React from 'react';
import { bookData } from '../data/mockData';

const ChaptersSection = () => {
  return (
    <section id="chapters" className="py-24 lg:py-32 bg-[#302f2c]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="mb-6 inline-block">
            <span className="caption text-[#d9fb06] bg-[#3f4816] px-4 py-2 rounded-full">
              CONTENIDO DEL LIBRO
            </span>
          </div>
          
          <h2 className="heading-2 text-[#d9fb06] mb-6">
            13 Capítulos de Conocimiento Profesional
          </h2>
          
          <p className="body-medium text-[#888680]">
            Una guía completa y estructurada desde los fundamentos hasta la 
            implementación práctica de tu marca personal.
          </p>
        </div>

        {/* Chapters List */}
        <div className="max-w-5xl mx-auto space-y-4">
          {bookData.chapters.map((chapter, index) => (
            <div
              key={chapter.number}
              className="group bg-[#1a1c1b] border border-[#3f4816] rounded-lg overflow-hidden hover:border-[#d9fb06] transition-all duration-300"
            >
              <div className="flex items-start gap-6 p-6 lg:p-8">
                {/* Chapter Number */}
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-lg bg-[#3f4816] group-hover:bg-[#d9fb06] flex items-center justify-center transition-colors duration-300">
                    <span className="text-2xl lg:text-3xl font-bold text-[#d9fb06] group-hover:text-[#1a1c1b]">
                      {chapter.number.toString().padStart(2, '0')}
                    </span>
                  </div>
                </div>

                {/* Chapter Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="heading-6 text-[#d9fb06] mb-2 lg:mb-3 group-hover:text-[#d9fb06] transition-colors">
                    {chapter.title}
                  </h3>
                  <p className="body-small text-[#888680] group-hover:text-[#dfddd6] transition-colors">
                    {chapter.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Plus Section */}
        <div className="mt-12 bg-[#1a1c1b] border-2 border-[#d9fb06] rounded-lg p-8 lg:p-10 text-center">
          <h3 className="heading-5 text-[#d9fb06] mb-4">
            Bonus: Cuaderno de Desarrollo Personal
          </h3>
          <p className="body-medium text-[#888680] max-w-2xl mx-auto">
            Incluye ejercicios prácticos, herramientas de autoevaluación, 
            plantillas aplicables y un plan estructurado para tus primeros 90 días 
            como entrenador profesional.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ChaptersSection;
